/* Success.ts */

/* Interfaces */
import { GlobalMessageType } from "src/shared/constants/common/GlobalMessage";
import { SuccessProps } from "src/shared/interfaces/common/GlobalMessage";

export class Success {
  public type: GlobalMessageType;
  public message: string;

  constructor({ type, message }: SuccessProps) {
    this.type = type;
    this.message = message;
  }
}
